var app = angular.module("leonardo");

var TableFilterController = function($scope, $filter, $q, $timeout, $rootScope, paginationService) {
  $scope.collection = {};
  $scope.datas = {};
  $scope.dontShow = true;
  $scope.order = $scope.order || null;
  $scope.page = $scope.page || 1;
  $scope.lastElementClicked = null;

  $scope.getContent = function() {
    var content = angular.element('.wrapper-columns-column.region-main .content-column');
    if (content.length === 0){
      content = angular.element('.layout-main');
    }
    return content;
  };

  $scope.updateData = function() {
    var data = {count: 0};
    var new_count = 0;
    var old_count = data.count;
    angular.forEach($scope.datas, function (value) {
      new_count = value.meta ? value.meta.count : value.count;
      old_count = data.meta ? data.meta.count : data.count;
      if (new_count >= old_count) {
        data = value;
      }
    });
    return data;
  };

  if ($scope.loadPage === undefined) {
    $scope.loadPage = function(page, noCancel) {
      var defer = $q.defer();
      var headheight = ($scope.getContent().length > 0) ? $scope.getContent().offset().top : 0;
      var element = document.getElementById($scope.lastElementClicked);
      var top = element ? element.offsetTop : 0;
      $timeout(function() {
        var options = angular.copy($scope.filters);
        $scope.page = options['page'] = page;
        options['ordering'] = $scope.order;
        options['limit'] = $scope.tableFilterSize;
        $scope.getEntitiesPromise(options, noCancel).then(function(list) {
          var results = list.results ? list.results : list;
          var count = list.meta ? list.meta.count : list.count;
          $scope.dontShow = count <= 0;
          if (options['order']) {
            var desc = (options['desc'] !== undefined) ? options['desc'] : true;
            $scope.collection['results'] = $filter('orderBy')(results, options['order'], desc);
          }
          else {
            $scope.collection['results'] = results;
          }
          $scope.collection['total'] = count;
          if ($scope.lastElementClicked) {
            $timeout(function() {
              $scope.getContent().animate({
                scrollTop: document.getElementById($scope.lastElementClicked) ? top + headheight - 20: 0
              }, 100);
            }, 200);
          }
          defer.resolve();
        }, function(error){
          if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
            $scope.loadPage(1);
          }
          else {
            defer.reject();
          }
        });
      }, 0);
      return defer.promise;
    };
  }

  if ($scope.filterKeys === undefined) {
    $scope.filterKeys = [];
  }

  if ($scope.getInitialFilters === undefined) {
    $scope.getInitialFilters = function(loadURLFilters) {
      var filters = {};
      angular.forEach($scope.filterKeys, function(key) {
        filters[key] = '';
      });
      if (loadURLFilters) {
        filters = $scope.setURLFilters(filters);
      }
      return filters;
    };
  }

  $scope.setURLFilters = function(filters) {
    var uri = new URI();
    var params = uri.query(true);
    angular.forEach($scope.filterKeys, function(key) {
      if (params[key] !== undefined) {
        filters[key] = isNaN(params[key]) ? params[key] : Number(params[key]);
      }
    });
    return filters;
  };

  $scope.filters = $scope.getInitialFilters(true);

  if ($scope.getTableFilterCollection === undefined) {
    $scope.getTableFilterCollection = function() {
      return $scope.collection;
    };
  }

  if ($scope.tableFilterCollectionChanged === undefined) {
    $scope.tableFilterCollectionChanged = function(page) {
        $scope.loadPage(page);
    };
  }

  $scope.hasFilters = function() {
    var count = 0;
    angular.forEach($scope.filters, function(value, key) {
      if (value && value !== '') {
        count++;
      }
    });
    return count !== 0;
  };

  $scope.clearFilters = function() {
    $scope.filters = $scope.getInitialFilters(false);
    $scope.loadPage(1);
  };

  $scope.orderBy = function (order) {
    if ($scope.order !== order) {
      $scope.order = order;
    }
    else {
      $scope.order = '-' + order;
    }
    $scope.loadPage($scope.page);
  };

  $scope.filter = function() {
    $scope.loadPage(1);
  };

  $scope.tableFilterCollection = $scope.getTableFilterCollection();

  if ($scope.tableFilterSize === undefined) {
    $scope.tableFilterSize = 50;
  }

  $scope.$on('filter-selection:updated', function(){
    const instances = paginationService.getInstances();
    angular.forEach(instances, function (instance, paginationId) {
      if (instance.currentPageParser){
        paginationService.setCurrentPage(paginationId, 1);
      }
    });
    $scope.loadPage(1);
  });

  $scope.$on('$destroy', function() {
    $scope.tableFilterSize = null;
    $scope.collection = {};
    $scope.tableFilterCollection = {};
    $scope.dontShow = true;
  });

};

app.controller('TableFilterController', ['$scope', '$filter', '$q', '$timeout', '$rootScope', 'paginationService', TableFilterController]);
